import React, { useState, useRef, useEffect } from "react";
import CountUp from "react-countup";

const Section7 = () => {
  const [counterOn, setCounterOn] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];

        if (entry.isIntersecting) {
          // Start counter when entering
          setCounterOn(true);
        } 
        else {
          // Reset counter when leaving section
          setCounterOn(false);
        }
      },
      { threshold: 0.1 } // Smooth, triggers only when 40% is in view
    );

    if (sectionRef.current) observer.observe(sectionRef.current);

    return () => observer.disconnect();
  }, []);

  return (
    <section className="home-section-7" ref={sectionRef}>
      <div className="container sect-7-container">
        <div className="row">

          {/* Counter 1 */}
          <div
            className="counter counter-1 col-lg-4 col-md-4 col-sm-12"
            data-aos="fade-down"
            data-aos-duration="1000"
          >
            <p className="counter-number">
              {counterOn && <CountUp start={0} end={16} duration={2} />}
            </p>
            <p className="counter-title">Industries</p>
          </div>

          {/* Counter 2 */}
          <div
            className="counter counter-2 col-lg-4 col-md-4 col-sm-12"
            data-aos="fade-down"
            data-aos-duration="1000"
          >
            <p className="counter-number">
              {counterOn && <CountUp start={0} end={100} duration={2} />}+
            </p>
            <p className="counter-title">Clients</p>
          </div>

          {/* Counter 3 */}
          <div
            className="counter counter-3 col-lg-4 col-md-4 col-sm-12"
            data-aos="fade-down"
            data-aos-duration="1000"
          >
            <p className="counter-number">
              {counterOn && <CountUp start={0} end={10} duration={2} />}+
            </p>
            <p className="counter-title">Countries</p>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Section7;
